'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { selectIsAuthenticated } from '@repo/store/maps/slices/auth';
import { selectCompassCtaPinId, setCompassCtaPinId } from '@repo/store/maps/slices/clientContext';
import { selectExternalMapId, selectTrainerConnected } from '@repo/store/maps/slices/mapData';
import { HostType } from '@repo/types/host';
import { useCallback, useEffect, useRef } from 'react';
interface UseCompassCtaOptions {
  enabled: boolean;
  isMobileWeb: boolean;
  selectedLocationId?: string | null;
}
export function useCompassCta(t0) {
  const $ = _c(27);
  const {
    enabled,
    isMobileWeb,
    selectedLocationId
  } = t0;
  const analytics = useAnalytics();
  const dispatch = useAppDispatch();
  const hostType = useHostType();
  const pinId = useAppSelector(selectCompassCtaPinId);
  const trainerConnected = useAppSelector(selectTrainerConnected);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const mapId = useAppSelector(selectExternalMapId);
  const wasOpenRef = useRef(false);
  const isOpen = enabled && hostType === HostType.WEB && !isMobileWeb && !trainerConnected && pinId === selectedLocationId;
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => dispatch(setCompassCtaPinId(null));
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const close = t1;
  let t2;
  let t3;
  if ($[2] !== close || $[3] !== enabled || $[4] !== pinId || $[5] !== selectedLocationId || $[6] !== trainerConnected) {
    t2 = () => {
      if (pinId && (!enabled || trainerConnected || pinId !== selectedLocationId)) {
        close();
      }
    };
    t3 = [close, enabled, pinId, selectedLocationId, trainerConnected];
    $[2] = close;
    $[3] = enabled;
    $[4] = pinId;
    $[5] = selectedLocationId;
    $[6] = trainerConnected;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] !== analytics || $[10] !== hostType || $[11] !== isAuthenticated || $[12] !== isOpen || $[13] !== mapId || $[14] !== pinId) {
    t4 = () => {
      if (!isOpen || !pinId) {
        wasOpenRef.current = false;
        return;
      }
      if (wasOpenRef.current) {
        return;
      }
      wasOpenRef.current = true;
      analytics.event("game_map_compass_cta_impression", {
        mapId,
        locationId: pinId,
        platform: hostType,
        isAuthenticated
      });
    };
    t5 = [analytics, hostType, isAuthenticated, isOpen, mapId, pinId];
    $[9] = analytics;
    $[10] = hostType;
    $[11] = isAuthenticated;
    $[12] = isOpen;
    $[13] = mapId;
    $[14] = pinId;
    $[15] = t4;
    $[16] = t5;
  } else {
    t4 = $[15];
    t5 = $[16];
  }
  useEffect(t4, t5);
  let t6;
  if ($[17] !== analytics || $[18] !== hostType || $[19] !== isAuthenticated || $[20] !== mapId || $[21] !== pinId) {
    t6 = () => {
      if (!pinId) {
        return;
      }
      analytics.event("game_map_compass_cta_download_click", {
        mapId,
        locationId: pinId,
        platform: hostType,
        isAuthenticated
      });
    };
    $[17] = analytics;
    $[18] = hostType;
    $[19] = isAuthenticated;
    $[20] = mapId;
    $[21] = pinId;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const handleDownloadClick = t6;
  let t7;
  if ($[23] !== close || $[24] !== handleDownloadClick || $[25] !== isOpen) {
    t7 = {
      close,
      handleDownloadClick,
      isOpen
    };
    $[23] = close;
    $[24] = handleDownloadClick;
    $[25] = isOpen;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}